import React from 'react';
import { FlatButton, Dialog, TextField, Checkbox } from 'material-ui';
import { connect } from 'react-redux';
import R from 'ramda';

const ManageFolderDialog = ({
                              manageFolderDialogOpen,
                              folderAction,
                              hoveringOverContractId,
                              folders,
                              selectedContracts,
                              newFolderName,
                              newFolderErrorText,
                              createFolderAndAssign,
                              updateProps,
                              selectedFolders,
                              contractFolders,
                              companyType,
                              hideContractInFolder,
                            }) => {
  const isMoveOut = folderAction === 'moveOut';
  const bulkMovingContractsOut = selectedContracts && selectedContracts.length && isMoveOut;
  return (
    <Dialog
      open={manageFolderDialogOpen}
      contentStyle={{ width: '400px' }}
      onRequestClose={() => updateProps({ manageFolderDialogOpen: false, newFolderName: '', newFolderErrorText: '' })}
      title={R.call(R.cond([
        [() => bulkMovingContractsOut, R.always(`Move ${selectedContracts.length} contracts out of ${selectedFolders[0]}`)],
        [() => isMoveOut, R.always('Move out of folders')],
        [R.T, R.always('Assign contracts to folders')],
      ]))}
      actions={[
        <FlatButton label="cancel" onTouchTap={() => updateProps({ manageFolderDialogOpen: false, newFolderName: '', newFolderErrorText: '', selectedFolders: [] })} />,
        <FlatButton label="save" disabled={!newFolderName && R.propOr(0, 'length', selectedFolders) === 0} secondary onTouchTap={() => {
          if (R.contains(newFolderName, folders)) updateProps({ newFolderErrorText: 'Folder Exists' });
          else {
            createFolderAndAssign({
              folderNames: newFolderName ? R.append(newFolderName, selectedFolders) : selectedFolders,
              contractIds: selectedContracts.length ? selectedContracts : [hoveringOverContractId],
              newFolderToCreate: newFolderName,
              hideContractInFolder,
              moveOutOfFolders: isMoveOut,
            });
            updateProps({ manageFolderDialogOpen: false, newFolderName: '', newFolderErrorText: '', folders: newFolderName ? R.append(newFolderName, folders) : folders, selectedFolders: [] });
          }
        }}
        />,
      ]}
    >
      {
        bulkMovingContractsOut ? <div/> : (
          <div>
            {
              isMoveOut && (
                <div style={{ marginBottom: '24px' }}>
                  Please select the folder(s) that you want to move your contract out of.
                </div>
              )
            }
            {
              (isMoveOut ? contractFolders : folders).map((folder, folderIndex) => (
                <Checkbox
                  checked={R.contains(folder, selectedFolders)}
                  labelPosition="right"
                  label={folder}
                  key={folderIndex}
                  onCheck={(_, checked) => updateProps({ selectedFolders: !checked ? R.reject(R.equals(folder), selectedFolders) : R.uniq(R.append(folder, selectedFolders)) })}
                />))
            }
            <div style={{ display: folderAction === 'moveOut' ? 'none' : 'flex', alignItems: 'center' }}>
              <Checkbox
                style={{ width: '40px' }}
                checked={Boolean(newFolderName)}
                onCheck={() => updateProps({ newFolderName: '', newFolderErrorText: '' })}
              />
              <TextField className="create-folder-input" id="create-folder-input" hintText="New Folder" value={newFolderName} errorText={newFolderErrorText} autoFocus onChange={(_, val) => updateProps({ newFolderName: val, newFolderErrorText: '' })} />
            </div>
            <div
              style={{ borderTop: '1px solid #e0e0e0', paddingTop: '12px', marginTop: '12px' }}
            >
              <label>Folder Setting:</label>
              <br/>
              <small>Making changes here affect all contracts in folders.</small>
              <Checkbox
                style={{ marginTop: '12px' }}
                label={companyType === 'Contractor'
                  ? 'Hide contracts from Received Rates or Requests Sent'
                  : 'Hide contracts from Requests or Rates Sent'}
                checked={hideContractInFolder}
                onCheck={() => updateProps({ hideContractInFolder: !hideContractInFolder })}
              />
            </div>
          </div>
        )
      }
    </Dialog>
  );
};

const mapStateToProps = ({ contracting, user }) => ({
  companyType: user.getIn(['company', 'companyType']),
  hideContractInFolder: contracting.contractList.get('hideContractInFolder'),
  selectedFolders: contracting.contractList.get('selectedFolders').toJS(),
  folders: contracting.contractList.get('folders').toJS(),
  hoveringOverContractId: contracting.contractList.get('hoveringOverContractId'),
  selectedContracts: contracting.contractList.get('selectedContracts').toJS(),
  manageFolderDialogOpen: contracting.contractList.get('manageFolderDialogOpen'),
  newFolderName: contracting.contractList.get('newFolderName'),
  newFolderErrorText: contracting.contractList.get('newFolderErrorText'),
  folderAction: contracting.contractList.get('folderAction'),
  contractFolders: contracting.contractList.toJS().contractFolders,
});

export default connect(mapStateToProps)(ManageFolderDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/manage-folder-dialog.jsx